import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import TextField from 'material-ui/TextField'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import UncheckedRadioButton from 'material-ui/svg-icons/toggle/radio-button-unchecked'
import IconButton from 'material-ui/IconButton'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Clear from 'material-ui/svg-icons/content/clear'
import { FormattedMessage } from 'react-intl'
import Dropzone from 'react-dropzone'
import modalType from './ModalHOC'
import { ALertHeaderText, AlertText } from '../../../components/Seminars/SeminarActions/styles'
import { getToken } from '../../../lib'
import images from '../../../config/images'

export class AddPersonModal extends Component {
  state = {
    name:
      this.props.user && this.props.user.username
        ? this.props.user.username
        : '',
    email:
      this.props.user && this.props.user.userEmail
        ? this.props.user.userEmail
        : '',
    nameError: '',
    emailError: '',
    role: 'student'
  }
  handleSubmit = e => {
    e.preventDefault()
    const {name, email, role} = this.state
    const token = getToken()
    if (name.length === 0 && email.length === 0) {
      return this.setState({nameError: true, emailError: true})
    }

    if (name.length === 0 || email.length === 0) {
      if (name.length === 0 && email.length !== 0) {
        return this.setState({nameError: true, emailError: false})
      } else if (name.length !== 0 && email.length === 0) {
        return this.setState({nameError: false, emailError: true})
      }
    }
    if (this.props.user) {
      this.props.editPerson(
        token,
        name,
        email,
        role,
        this.props.user.listId,
        this.props.contactId
      )
      this.props.snackbarOpen(<FormattedMessage id="contacts.userEdited"/>)
      return this.props.handleClose()
    }
    this.props.addPerson(token, name, email, role, this.props.contactId)
    this.props.snackbarOpen(<FormattedMessage id="contacts.userAdded"/>)
    this.props.handleClose()
  }

  handleChange = (e, purpose) => {
    if (purpose === 'name') {
      this.setState({name: e.target.value})
    } else if (purpose === 'email') {
      this.setState({email: e.target.value})
    }
  }

  handleRoleChange = (e, value) => this.setState({role: value})

  render () {
    const {user} = this.props
    return (
      <div>
        <div className="flex justify-between items-center">
          <ALertHeaderText>
            <FormattedMessage id="contacts.add"/>
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <form autoComplete="off" onSubmit={this.handleSubmit}>
            <div className="mb4">
              <TextField
                errorText={
                  this.state.nameError ? (
                    <FormattedMessage id="login.requiredField"/>
                  ) : null
                }
                hintText="Jon Doe"
                value={this.state.name}
                onChange={e => this.handleChange(e, 'name')}
                floatingLabelText={<FormattedMessage id="contacts.name"/>}
                fullWidth
              />
              <TextField
                errorText={
                  this.state.emailError ? (
                    <FormattedMessage id="login.requiredField"/>
                  ) : null
                }
                hintText="abc@abc.com"
                value={this.state.email}
                onChange={e => this.handleChange(e, 'email')}
                floatingLabelText={<FormattedMessage id="login.emailLable"/>}
                type="email"
                fullWidth
              />
            </div>
            <div style={{fontSize: 12}} className="mb3 ttc">
              <FormattedMessage id="contacts.role"/>
            </div>
            <div className="mb4 flex items-center justify-between">
              <RadioButtonGroup
                onChange={this.handleRoleChange}
                valueSelected={this.state.role}
                name="shipSpeed"
                defaultSelected={user && user.role ? user.role : 'student'}
                className="w-90"
                style={{fill: 'red'}}
              >
                <RadioButton
                  value="student"
                  label={<FormattedMessage id="inviteModal.student"/>}
                  iconStyle={{fill: '#45CE90'}}
                  uncheckedIcon={
                    <UncheckedRadioButton style={{fill: '#6B7C93'}}/>
                  }
                  style={{paddingBottom: '1rem'}}
                  labelStyle={{color: '#6B7C93'}}
                />
                <RadioButton
                  value="teacher"
                  label={<FormattedMessage id="inviteModal.teacher"/>}
                  iconStyle={{fill: '#45CE90'}}
                  uncheckedIcon={
                    <UncheckedRadioButton style={{fill: '#6B7C93'}}/>
                  }
                  style={{paddingBottom: '1rem'}}
                  labelStyle={{color: '#6B7C93'}}
                />
              </RadioButtonGroup>
            </div>
            <div className="flex justify-end mb4">
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                onTouchTap={this.props.handleClose}
              />
              <RaisedButton
                className="ml3"
                backgroundColor="#FCCE42"
                type="submit"
                label={
                  user ? (
                    <FormattedMessage id="contacts.save"/>
                  ) : (
                    <FormattedMessage id="contacts.addLabel"/>
                  )
                }
              />
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export class CreateList extends Component {
  state = {
    nameError: false,
    name: this.props.name ? this.props.name : '',
    redirectToListPage: false
  }

  handleChange = e => this.setState({name: e.target.value, nameError: false})
  handleSubmit = e => {
    e.preventDefault()
    const {name} = this.state
    const token = getToken()
    if (name.length === 0) {
      return this.setState({nameError: true})
    }
    if (this.props.name) {
      this.props.updateContactList(token, name, this.props.contactId)
      this.setState({redirectToListPage: true})
      return this.props.handleClose()
    } else {
      this.props.createContactList(token, name)
      this.props.handleClose()
    }
  }

  render () {
    if (this.state.redirectToListPage) {
      return (
        <Redirect
          to={{
            pathname: `/admin/contact-list/${this.state.name}`,
            state: {id: this.props.contactId}
          }}
        />
      )
    }
    return (
      <div>
        <div className="flex justify-between items-center">
          <ALertHeaderText>
            {this.props.name ? (
              <FormattedMessage id="contacts.editLabel"/>
            ) : (
              <FormattedMessage id="contacts.addLabel"/>
            )}{' '}
            <FormattedMessage id="contacts.list"/>
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <TextField
            value={this.state.name}
            onChange={this.handleChange}
            errorText={
              this.state.nameError ? (
                <FormattedMessage id="login.requiredField"/>
              ) : null
            }
            hintText="Anet seminar"
            floatingLabelText={<FormattedMessage id="contacts.listName"/>}
            fullWidth
            className="mb4"
          />
          <div className="flex justify-end mb4">
            <FlatButton
              label={<FormattedMessage id="loggedInNavigation.cancel"/>}
              onTouchTap={this.props.handleClose}
            />
            <RaisedButton
              className="ml3"
              type="submit"
              backgroundColor="#FCCE42"
              label={
                this.props.name ? (
                  <FormattedMessage id="contacts.save"/>
                ) : (
                  <FormattedMessage id="contacts.addLabel"/>
                )
              }
            />
          </div>
        </form>
      </div>
    )
  }
}

export class DeleteListModal extends Component {
  state = {
    redirectToListPage: false
  }
  handleTouchTap = () => {
    const token = getToken()
    this.props.handleClose()
    this.props.deleteContactList(token, this.props.contactId)
    this.setState({redirectToListPage: true})
  }

  render () {
    if (this.state.redirectToListPage) {
      return (
        <Redirect
          to={'/admin/contacts'}
        />
      )
    }

    return (
      <div>
        <div className="flex justify-between items-center">
          <ALertHeaderText>
            <FormattedMessage id="contacts.deleteList"/>
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <AlertText className="mt3 mb3">
          <FormattedMessage id="contacts.sureDelete"/>
        </AlertText>
        <div className="flex justify-end">
          <div className="w4">
            <FlatButton
              label={<FormattedMessage id="loggedInNavigation.cancel"/>}
              fullWidth
              onTouchTap={this.props.handleClose}
            />
          </div>
          <div className="ml2 w4">
            <FlatButton
              label={<FormattedMessage id="contacts.delete"/>}
              fullWidth
              backgroundColor="#F01631"
              labelStyle={{color: '#FFFFFF'}}
              onTouchTap={this.handleTouchTap}
            />
          </div>
        </div>
      </div>
    )
  }
}

export class CsvImport extends Component {
  state = {
    fileName: undefined,
    accepted: false,
    file: null
  }

  handleUpload = () => {
    const token = getToken()
    this.props
      .csvUpload(token, this.state.file, this.props.contactId, 'no')
      .then(res => {
        if (!res.errors) {
          this.props.handleClose()
          this.props.fetchListDetails(token, this.props.contactId)
        } else {
          this.setState({
            accepted: false,
            errorText: 'Something went wrong please try again!'
          })
        }
      })
  }

  handleAccept = file => {
    const token = getToken()
    this.props
      .csvUpload(token, file[0], this.props.contactId, 'yes')
      .then(res => {
        if (res.errors) {
          this.setState({
            fileName: file[0].name,
            accepted: false,
            errorText: 'Unsupported file'
          })
        } else {
          this.setState({
            fileName: file[0].name,
            accepted: true,
            file: file[0]
          })
        }
      })
  }

  render () {
    return (
      <div>
        <div className="flex justify-between items-center">
          <ALertHeaderText>
            <FormattedMessage id="contacts.importCsv"/>
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div className="mt3">
          <div style={{fontSize: 20, color: '#29B87A', fontWeight: 'bold'}}>
            <FormattedMessage id="contacts.supportedFormat"/>
          </div>
          <div className="mt2">
            <img src={images.csv} alt="csv"/>
          </div>
          <div className="mt3 flex justify-center">
            <Dropzone
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 250,
                height: 250,
                borderWidth: 2,
                borderColor: 'rgb(102, 102, 102)',
                borderStyle: 'dashed',
                borderRadius: '100%'
              }}
              multiple={false}
              accept=".csv"
              onDropAccepted={file => this.handleAccept(file)}
              onDropRejected={file =>
                this.setState({
                  fileName: file[0].name,
                  accepted: false,
                  errorText: 'Unsupported file'
                })}
            >
              <p className="tc w-100" style={{overflowWrap: 'break-word'}}>
                {this.state.fileName ? (
                  this.state.fileName
                ) : (
                  <FormattedMessage id="contacts.chooseCsv"/>
                )}
              </p>
            </Dropzone>
          </div>
          {this.state.fileName ? (
            this.state.accepted ? (
              <div className="flex justify-end mt3">
                <div className="w-50">
                  <FlatButton
                    label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                    fullWidth
                    onTouchTap={() =>
                      this.setState({accepted: false, fileName: undefined})}
                  />
                </div>
                <div className="w-50">
                  <FlatButton
                    label={<FormattedMessage id="seminarActions.import"/>}
                    fullWidth
                    hoverColor="#339B6C"
                    backgroundColor="#46CE90"
                    labelStyle={{color: '#FFFFFF'}}
                    onTouchTap={this.handleUpload}
                  />
                </div>
              </div>
            ) : (
              <div style={{fontSize: 20, color: '#D0021B'}}>
                {this.state.errorText}
              </div>
            )
          ) : (
            ''
          )}
          <div/>
        </div>
      </div>
    )
  }
}

const Modal = ({children}) => <div>{children}</div>

export default modalType(Modal)



// WEBPACK FOOTER //
// ./src/routes/Contacts/ListName/Modals.js